import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DonationService, MemberService, NoteResponseDto, NoteService } from 'src/app/backend';
import { SaveDonationDialogComponent } from 'src/app/shared/dialogs/save-donation-dialog/save-donation-dialog.component';
import { SaveNeedDialogComponent } from 'src/app/shared/dialogs/save-need-dialog/save-need-dialog.component';
import { SaveNoteDialogComponent } from 'src/app/shared/dialogs/save-note-dialog/save-note-dialog.component';
import { FamilyService } from '../../backend/api/family.service';
import { DonationResponseDto } from '../../backend/model/donationResponseDto';
import { MemberResponseDto } from '../../backend/model/memberResponseDto';
import { SexEnum } from '../../backend/model/sexEnum';
import { BasePagedComponent } from '../../core/components/base-paged/base-paged.component';
import { DialogService } from '../../core/dialog/dialog.service';
import { AuthService } from '../../core/services/auth.service';
import { ConfirmDialogComponent } from '../../shared/dialogs/confirm-dialog/confirm-dialog.component';
import { SaveMemberDialogComponent } from '../../shared/dialogs/save-member-dialog/save-member-dialog.component';
import { SaveFamilyDialogComponent } from './../../shared/dialogs/save-family-dialog/save-family-dialog.component';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

interface UserRow {
  id: number;
  representative: string;
  phone: string;
  address: string;
  city: string;
  residence: string;
  documents: boolean;
  members: MemberResponseDto[];
  donations: DonationResponseDto[];
  notes: NoteResponseDto[];
}

@Component({
  selector: 'app-families',
  templateUrl: './families.component.html',
  styleUrls: ['./families.component.scss'],
})
export class FamiliesComponent extends BasePagedComponent implements OnInit {
  data: UserRow[] = [];
  searchQueryControl = new UntypedFormControl('');
  searchQueryControlResidence = new UntypedFormControl('');
  searchQueryControlCity = new UntypedFormControl('');
  haveDocumentsId = new UntypedFormControl('');
  isLoading = false;
  expandSet = new Set<number>();
  haveDocuments: { id: number, name: string }[] = [  { id: 0, name: 'Bez Dokumenata' },
  { id:   1, name: 'Sa Dokumentima' },
  { id: 2, name: 'Sve' }];



  constructor(
    private dialogService: DialogService,
    private familiesService: FamilyService,
    private membersService: MemberService,
    private donationService: DonationService,
    private noteService: NoteService,
    authService: AuthService,
    private t: TranslateService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;

    this.familiesService
      .apiFamilyGet({
        ...this.tableData,
        filter: JSON.stringify({
          search: this.searchQueryControl.value,
          residence: this.searchQueryControlResidence.value,
          city: this.searchQueryControlCity.value,
          haveDocuments: this.haveDocumentsId.value,
          
        }),
      })
      .subscribe(
        (res) => {
          this.pageLoaded(res);
          this.isLoading = false;
          this.data =
            res.results?.map((x) => ({
              id: x.id || 0,
              representative: x.representative || '',
              phone: x.phone || '',
              address: x.address || '',
              city: x.city || '',
              documents: x.documents || false,
              members: x.members || [],
              donations: x.donations || [],
              notes: x.notes || [],
              residence: x.residence || ''
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  searchFamilies() {
    this.loadData();
  }

  formatDate(date: any)
  {
    return moment(date).format('MM/DD/YYYY');
  }

  addNote(id: number)
{
  this.dialogService
  .open(SaveNoteDialogComponent, {
    size: 'md',
    closeOnClickOutside: true,
    data: {
      familyId: id
    }
  })
  .afterClosed.subscribe((res) => {
    if (res?.saved) {
      this.loadData();
    }
  });
}

addDonation(id: number)
{
  this.dialogService
  .open(SaveDonationDialogComponent, {
    size: 'md',
    closeOnClickOutside: true,
    data: {
      familyId: id
    }
  })
  .afterClosed.subscribe((res) => {
    if (res?.saved) {
      this.loadData();
    }
  });
}

addNeed(id: number)
{
  this.dialogService
  .open(SaveNeedDialogComponent, {
    size: 'md',
    closeOnClickOutside: true,
    data: {
      familyId: id
    }
  })
  .afterClosed.subscribe((res) => {
    if (res?.saved) {
      this.loadData();
    }
  });
}


  new() {
    this.dialogService
      .open(SaveFamilyDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  edit(id: number) {
    this.dialogService
      .open(SaveFamilyDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
        data: {
          id,
        },
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  delete(id: number) {
    this.dialogService
      .open(ConfirmDialogComponent, {
        size: 'md',
      })
      .afterClosed.subscribe((res) => {
        if (res?.confirmed) {
          this.familiesService.apiFamilyIdDelete({ id }).subscribe((res) => {
            this.loadData();
          });
        }
      });
  }

  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  getGender(gender?: SexEnum) {
    if (gender === SexEnum.Female) {
      return this.t.instant('female');
    } else if (gender === SexEnum.Male) {
      return this.t.instant('male');
    }

    return '/';
  }

  addMember(familyId: number) {
    this.dialogService
      .open(SaveMemberDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
        data: {
          familyId,
        },
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  deleteFamilyMember(id: number) {
    this.dialogService
      .open(ConfirmDialogComponent, {
        size: 'md',
      })
      .afterClosed.subscribe((res) => {
        if (res?.confirmed) {
          this.membersService.apiMemberIdDelete({ id }).subscribe((res) => {
            this.loadData();
          });
        }
      });
  }

  deleteNoteDonation(id: number) {
    this.dialogService
      .open(ConfirmDialogComponent, {
        size: 'md',
      })
      .afterClosed.subscribe((res) => {
        if (res?.confirmed) {
          this.noteService.apiNoteIdDelete({ id }).subscribe((res) => {
            this.loadData();
          });
        }
      });
  }

  deleteMemberDonation(id: number) {
    this.dialogService
      .open(ConfirmDialogComponent, {
        size: 'md',
      })
      .afterClosed.subscribe((res) => {
        if (res?.confirmed) {
          this.donationService.apiDonationIdDelete({ id }).subscribe((res) => {
            this.loadData();
          });
        }
      });
  }

  editFamilyMember(id: number) {
    this.dialogService
      .open(SaveMemberDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
        data: { id },
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }
}
